export const HEADERS = [
  {
    textKey: 'miscellaneous.image',
    value: 'image',
    width: 80,
    sortable: false,
  },
  {
    textKey: 'generalAttributes.name',
    value: 'name',
    width: 440,
    sortable: false,
  },
  {
    textKey: 'generalAttributes.description',
    value: 'description',
    sortable: false,
  },
  {
    textKey: 'entities.categories.entity',
    value: 'category',
    width: 140,
    sortable: false,
  },
  {
    textKey: 'entities.products.numberOfVariants',
    value: 'variantsCount',
    width: 80,
    sortable: false,
  },
  {
    textKey: 'miscellaneous.actions',
    value: 'actions',
    align: 'end',
    width: 144,
    sortable: false,
  },
]
